var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 8C15 9.4626 14.5419 10.8885 13.6899 12.0773C12.838 13.2662 11.6351 14.1584 10.2501 14.6285C8.86509 15.0986 7.36763 15.1232 5.96801 14.6986C4.56838 14.274 3.3369 13.4217 2.44653 12.2613C1.55615 11.101 1.0516 9.69085 1.00375 8.22903C0.955893 6.76721 1.36713 5.32712 2.17971 4.11101C2.99229 2.8949 4.16539 1.96386 5.53425 1.44866C6.90311 0.933456 8.39897 0.859969 9.81173 1.23852",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.a367da12017e0a0974e73a44d6a5bd93.svg";
export { ForwardRef as ReactComponent };